import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/[locale]/calculator/CalculatorUI.tsx");
